import { normalizeFetchProgressResponse, normalizeFetchVersionsResponse } from './utils/normalizers/version.normalizers'
import { ASSIGNMENT_TAG, createTagsForList, SUBMISSION_TAG, VERSION_TAG } from './utils/tags'
import { actions } from '../reducers/assignments.reducer'
import baseApi from './base.api'

export const versionApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchVersions: builder.query({
            query: ({ token, publishedOnly }) => ({
                url: `/versions/${token}`,
                method: 'GET',
                params: {
                    published_only: publishedOnly,
                },
            }),
            transformResponse: normalizeFetchVersionsResponse,
            providesTags: (result, error, arg) => [
                { type: VERSION_TAG, id: arg.token },
                ...createTagsForList(result, VERSION_TAG),
            ],
        }),
        fetchProgress: builder.query({
            query: ({ token }) => ({
                url: `/versions/${token}/progress`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchProgressResponse,
            providesTags: [SUBMISSION_TAG],
            /*providesTags: (result, error, arg) => [
                { type: VERSION_TAG, id: arg.token },
                ...createTagsForList(result, VERSION_TAG),
            ],*/
        }),
        createVersion: builder.mutation({
            query: ({ token, name, versionIdsToCopySubmissionsFrom, changesHistory, ticketNumber, changesAuthor }) => ({
                url: `/versions/${token}`,
                method: 'POST',
                data: {
                    name,
                    version_ids: versionIdsToCopySubmissionsFrom,
                    changes_history: changesHistory,
                    ticket_number: ticketNumber,
                    changes_author: changesAuthor,
                },
            }),
            invalidatesTags: (result, error, arg) => [{ type: VERSION_TAG, id: arg.token }],
        }),
        migrateMbaVersion: builder.mutation({
            query: ({ token, versionId }) => ({
                url: `/versions/${token}/switch-mba-version`,
                method: 'PUT',
                data: { version_id: versionId },
            }),
            invalidatesTags: (result, error, arg) => [{ type: ASSIGNMENT_TAG, id: arg.token }],
        }),
    }),
})

export const { useFetchProgressQuery, useFetchVersionsQuery, useCreateVersionMutation, useMigrateMbaVersionMutation } =
    versionApi
